import { useTranslation } from 'react-i18next';

import SectionTitle from 'components/SectionTitle';
import { CertificateDetailsModel } from 'models/certificate.model';

import Certificate from './Certificate';

interface RelatedCertificatesProps {
  additionalDetails?: CertificateDetailsModel;
  relatedFields: string[];
  batteryPackSerialNumber?: string;
}

const RelatedCertificates = ({
  additionalDetails,
  relatedFields,
  batteryPackSerialNumber,
}: RelatedCertificatesProps) => {
  const { t } = useTranslation();
  const relatedProductIds = [
    ...(additionalDetails?.details?.filter((f) => relatedFields.includes(f.label)) || []),
  ];

  return (
    <>
      <SectionTitle>{t('certificate.relatedCertificates')}</SectionTitle>

      {relatedProductIds?.map((p) => (
        <Certificate
          productId={p.value}
          key={p.value}
          batteryPackSerialNumber={batteryPackSerialNumber}
        />
      ))}
    </>
  );
};

export default RelatedCertificates;
